module.exports = __webpack_public_path__ + "img/map.817f955f.jpg";